// Contenu synchronisé avec la boutique BigCartel (API publique, CORS ouvert).
// - [data-bigcartel-workshops] : calendrier des ateliers (catégorie « Atelier »)
// - [data-bigcartel-products]  : derniers produits de la boutique, hors ateliers
// Si l'API ne répond pas, le contenu déjà présent dans la page est conservé.
(function() {
    const SHOP_URL = 'https://boutique.risonnable.fr';
    const API_URL = 'https://api.bigcartel.com/risonnable/products.json?limit=100';

    const MONTHS = ['janvier', 'fevrier', 'mars', 'avril', 'mai', 'juin', 'juillet', 'aout', 'septembre', 'octobre', 'novembre', 'decembre'];

    function escapeHtml(value) {
        return String(value).replace(/[&<>"']/g, function(c) {
            return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c];
        });
    }

    function normalize(text) {
        return text.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    }

    function isWorkshop(product) {
        return (product.categories || []).some(function(category) {
            return /^ateliers?$/.test(normalize(category.name));
        });
    }

    function formatPrice(price) {
        return (Number.isInteger(price) ? price : price.toFixed(2).replace('.', ',')) + ' €';
    }

    function imageUrl(image, width) {
        return image.secure_url + '?auto=format&fit=max&w=' + width;
    }

    // Reconnaît « 07/10/26 », « 07/10/2026 », « samedi 14 novembre 2026 » ou « 14 novembre »
    function parseDate(text) {
        const today = new Date();
        let day, month, year;

        const numeric = text.match(/(\d{1,2})\/(\d{1,2})\/(\d{2,4})/);
        const written = normalize(text).match(new RegExp('(\\d{1,2})(?:er)?\\s+(' + MONTHS.join('|') + ')(?:\\s+(\\d{4}))?'));

        if (numeric) {
            day = +numeric[1];
            month = +numeric[2] - 1;
            year = +numeric[3] < 100 ? 2000 + +numeric[3] : +numeric[3];
        } else if (written) {
            day = +written[1];
            month = MONTHS.indexOf(written[2]);
            year = written[3] ? +written[3] : today.getFullYear();
            // Sans année, une date déjà passée désigne l'année suivante
            if (!written[3] && new Date(year, month, day + 1) < today) {
                year++;
            }
        } else {
            return null;
        }

        const date = new Date(year, month, day);
        return date.getMonth() === month ? date : null;
    }

    // Reconnaît « de 19h à 21h », « 14h30 - 17h00 », « 14h-17h30 »
    function matchHours(text) {
        return text.match(/(\d{1,2})h(\d{2})?\s*(?:à|-|–|—)\s*(\d{1,2})h(\d{2})?/i);
    }

    function parseHours(text) {
        const match = matchHours(text);
        if (!match) {
            return '';
        }
        return match[1] + 'h' + (match[2] || '') + ' - ' + match[3] + 'h' + (match[4] || '');
    }

    function pad(number) {
        return String(number).padStart(2, '0');
    }

    // Date ISO sans fuseau : Google la lit à l'heure locale du lieu de l'événement (Tours)
    function isoDateTime(date, hours, minutes) {
        const day = date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
        return hours === undefined ? day : day + 'T' + pad(hours) + ':' + pad(minutes || 0);
    }

    function formatDate(date) {
        const label = date.toLocaleDateString('fr-FR', {weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'});
        return label.charAt(0).toUpperCase() + label.slice(1);
    }

    function upcomingWorkshops(products) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const sessions = [];
        products.filter(isWorkshop).forEach(function(product) {
            product.options.forEach(function(option) {
                const date = parseDate(option.name);
                if (!date || date < today) {
                    return;
                }
                const hours = matchHours(option.name);
                sessions.push({
                    name: product.name.trim(),
                    date: date,
                    hours: parseHours(option.name),
                    start: hours ? isoDateTime(date, hours[1], hours[2]) : isoDateTime(date),
                    end: hours ? isoDateTime(date, hours[3], hours[4]) : isoDateTime(date),
                    price: option.price,
                    soldOut: option.sold_out || product.status === 'sold-out',
                    url: SHOP_URL + product.url
                });
            });
        });

        return sessions.sort(function(a, b) {
            return a.date - b.date;
        });
    }

    function renderWorkshops(container, products) {
        const sessions = upcomingWorkshops(products);

        if (!sessions.length) {
            container.innerHTML = '<p class="text-center normal-text">Pas de nouvelle date pour le moment. Revenez bientôt ou <a class="underline" href="/devis/">écrivez-nous</a>&nbsp;!</p>';
            return;
        }

        const rows = sessions.map(function(session) {
            const action = session.soldOut
                ? 'Complet'
                : '<a class="underline" href="' + escapeHtml(session.url) + '">Réserver</a>';
            return '<tr>' +
                '<td>' + escapeHtml(session.name) + '</td>' +
                '<td>' + formatDate(session.date) + '</td>' +
                '<td>' + escapeHtml(session.hours) + '</td>' +
                '<td>' + formatPrice(session.price) + '</td>' +
                '<td>' + action + '</td>' +
            '</tr>';
        });

        container.innerHTML = '<table>' + rows.join('') + '</table>';
        addEventsStructuredData(sessions);
    }

    // Données structurées Event pour que Google puisse afficher les dates d'ateliers
    function addEventsStructuredData(sessions) {
        const events = sessions.map(function(session) {
            return {
                '@type': 'Event',
                name: session.name,
                startDate: session.start,
                endDate: session.end,
                eventStatus: 'https://schema.org/EventScheduled',
                eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
                location: {
                    '@type': 'Place',
                    name: 'Risonnable, atelier de risographie',
                    address: {
                        '@type': 'PostalAddress',
                        streetAddress: '3 rue du Poirier',
                        postalCode: '37000',
                        addressLocality: 'Tours',
                        addressCountry: 'FR'
                    }
                },
                organizer: {
                    '@type': 'Organization',
                    name: 'Risonnable',
                    url: 'https://risonnable.fr'
                },
                offers: {
                    '@type': 'Offer',
                    price: session.price,
                    priceCurrency: 'EUR',
                    availability: session.soldOut ? 'https://schema.org/SoldOut' : 'https://schema.org/InStock',
                    url: session.url
                }
            };
        });

        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.textContent = JSON.stringify({'@context': 'https://schema.org', '@graph': events});
        document.head.appendChild(script);
    }

    function renderProducts(container, products) {
        const count = +container.dataset.bigcartelProducts || 3;
        const latest = products
            .filter(function(product) {
                return !isWorkshop(product) && product.status === 'active' && !product.has_password_protection && product.images && product.images.length;
            })
            .sort(function(a, b) {
                return new Date(b.created_at) - new Date(a.created_at);
            })
            .slice(0, count);

        if (!latest.length) {
            return;
        }

        container.innerHTML = latest.map(function(product, index) {
            const categoryName = product.categories && product.categories[0] ? product.categories[0].name.trim() : '';
            // Les formats papier (A3, A4…) deviennent « Impression en A3 », les autres catégories restent telles quelles
            const category = categoryName ? (/^A\d$/i.test(categoryName) ? 'Impression en ' + categoryName : categoryName) + ' · ' : '';
            // Sur lg, la grille n'affiche que 2 colonnes : la 3e carte est masquée
            const visibility = index === 2 ? 'flex lg:hidden xl:flex' : 'flex';
            const margin = index < 2 ? ' mb-8 xl:mb-0' : '';
            return '<a href="' + escapeHtml(SHOP_URL + product.url) + '" target="_blank" rel="noopener noreferrer" class="md:col-span-4 lg:col-start-auto md:col-start-2 col-span-full relative flex-col ' + visibility + margin + '">' +
                '<img class="h-80 object-cover border-3 rounded-xl mb-8" src="' + escapeHtml(imageUrl(product.images[0], 800)) + '" alt="' + escapeHtml(product.name.trim()) + '" loading="lazy">' +
                '<div class="flex flex-col space-y-2">' +
                    '<h3 class="text-white">' + escapeHtml(product.name.trim()) + '</h3>' +
                    '<p class="normal-text text-white">' + escapeHtml(category) + formatPrice(product.price) + '</p>' +
                '</div>' +
            '</a>';
        }).join('');
    }

    document.addEventListener('DOMContentLoaded', function() {
        const workshops = document.querySelector('[data-bigcartel-workshops]');
        const shop = document.querySelector('[data-bigcartel-products]');

        if (!workshops && !shop) {
            return;
        }

        fetch(API_URL)
            .then(function(response) {
                if (!response.ok) {
                    throw new Error('BigCartel ' + response.status);
                }
                return response.json();
            })
            .then(function(products) {
                if (workshops) {
                    renderWorkshops(workshops, products);
                }
                if (shop) {
                    renderProducts(shop, products);
                }
            })
            .catch(function(error) {
                console.warn('Contenu BigCartel indisponible, contenu par défaut conservé.', error);
            });
    });
})();
